import React from 'react';
import { Box, Tooltip } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import {
  formatBoardOpeningTooltip,
  formatTruncatedCompactBoardOpeningLabel,
  type EcoOpeningFields,
} from './openingFormat';

type EcoOpeningLabelProps = {
  fields: EcoOpeningFields;
  sx?: SxProps<Theme>;
};

const EcoOpeningLabel = ({ fields, sx }: EcoOpeningLabelProps) => {
  const fullLabel = formatBoardOpeningTooltip(fields);
  const truncatedLabel = formatTruncatedCompactBoardOpeningLabel(fields);
  const hasOpening = fullLabel !== '—';
  const showTooltip = hasOpening && fullLabel !== truncatedLabel;

  return (
    <Tooltip
      title={fullLabel}
      disableHoverListener={!showTooltip}
      enterDelay={300}
      slotProps={{
        popper: {
          popperOptions: {
            strategy: 'fixed',
            modifiers: [
              {
                name: 'preventOverflow',
                options: {
                  altAxis: true,
                  tether: false,
                  rootBoundary: 'viewport',
                },
              },
            ],
          },
        },
        tooltip: {
          sx: { maxWidth: 320 },
        },
      }}
    >
      <Box
        component="span"
        sx={{
          display: 'inline-block',
          maxWidth: 220,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          verticalAlign: 'bottom',
          color: 'text.secondary',
          ...sx,
        }}
      >
        {truncatedLabel}
      </Box>
    </Tooltip>
  );
};

export default EcoOpeningLabel;
